export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/wmd-logo-event-spanish-4ee03a73fe9f3ea396fd5ab7841bbce7.svg";